import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";

import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { LOCALE_ID } from "@angular/core";

import { AppComponent } from "./app.component";
import { Ng2BootstrapModule } from "ng2-bootstrap";
import { NAV_DROPDOWN_DIRECTIVES } from "./shared/nav-dropdown.directive";
import { SIDEBAR_TOGGLE_DIRECTIVES } from "./shared/sidebar.directive";
import { AsideToggleDirective } from "./shared/aside.directive";
import { BreadcrumbsComponent } from "./shared/breadcrumb.component";
import { SmartResizeDirective } from "./shared/smart-resize.directive";

// Routing Module
import { AppRoutingModule } from "./app.routing";

// Layout
import { FullLayoutComponent } from "./layouts/full-layout.component";

// Authentication
import { AuthGuard } from "./_guards/index";
import { AuthenticationService } from "./_services/authentication.service";
import { UserService } from "./_services/user.service";
import { LoginComponent } from "./login/index";

// Others
import { EnvironmentService } from "./_services/environment.service";

// Landingpages
// import { ServiceCalculatorComponent } from "./landingpages/servicecalculator/index";
import { UsedCarsCalculatorComponent } from "./landingpages/usedcars/oder-flow";
import { UsedCarAdditionalProductsComponent } from "./landingpages/usedcars/oder-flow/additional-products.component";
import { FindCarComponent } from "./landingpages/findcar/index";
import { DealerPageComponent } from "./landingpages/dealerpage/index";
import { ProlongingsDealerPageComponent } from "./landingpages/prolongings/dealerpage/index";
import { UsedCarsDealerPageComponent } from "./landingpages/usedcars/dealerpage/index";

import { DealerServiceCalculatorComponent } from "./landingpages/dealerservicecalculator/index";
import { DealerServiceCheckoutComponent } from "./landingpages/dealerservicecheckout/index";
import { UserPermissionComponent } from "./landingpages/userpermission/index";
import { DormantfeedbackComponent } from "./landingpages/dormantfeedback/dormantfeedback.component";
import { ProlongingsAdditionalProductsComponent } from "./landingpages/prolongings/order-flow/additional-products.component";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";

import {
  ToasterModule,
  ToasterService,
} from "angular2-toaster/angular2-toaster";

import { CarworkshopdncComponent } from "./landingpages/carworkshopdnc/carworkshopdnc.component";
import { AgreementAcceptanceComponent } from "./landingpages/agreementacceptance/agreementacceptance.component";
import { TyreInfoComponent } from "./landingpages/tyreinfo";
import { TyreHotelCheckoutComponent } from "./landingpages/tyrehotelcheckout";
import { CustomerTyreSearchComponent } from "./landingpages/customertyresearch";
import { UsedCarsCheckoutComponent } from "./landingpages/usedcars/oder-flow/checkout.component";
import { ProlongingsCheckoutComponent } from "./landingpages/prolongings/order-flow/checkout.component";
import { UsedCarAgreementService } from "./_services/matrix/products/used-cars-agreement.service";
import { ProlongingsAgreementService } from "./_services/matrix/products/prolongings-agreement.service";
import { KmCatchUpAgreementService } from "./_services/matrix/products/km-catch-up-agreement.service";
import { MatrixCalculatorService } from "./_services/matrix/matrix-calculator.service";
import { MatrixCarService } from "./_services/matrix/matrix-cars.service";
import { ProlongingsCalculatorComponent } from "./landingpages/prolongings/order-flow";
import { CookieModule } from 'ngx-cookie';
import { KmCatchUpCalculatorComponent, KmCatchUpCheckoutComponent } from './landingpages/kmCatchUp/order-flow';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    Ng2BootstrapModule.forRoot(),
    HttpModule,
    NgbModule.forRoot(),
    CommonModule,
    ToasterModule,
    CookieModule.forRoot()
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    LoginComponent,
    // ServiceCalculatorComponent,
    FindCarComponent,
    DealerPageComponent,
    ProlongingsDealerPageComponent,
    UsedCarsDealerPageComponent,
    DealerServiceCalculatorComponent,
    DealerServiceCheckoutComponent,
    UserPermissionComponent,
    DormantfeedbackComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    SmartResizeDirective,
    CarworkshopdncComponent,
    AgreementAcceptanceComponent,
    TyreInfoComponent,
    TyreHotelCheckoutComponent,
    CustomerTyreSearchComponent,
    UsedCarsCalculatorComponent,
    UsedCarsCheckoutComponent,
    UsedCarAdditionalProductsComponent,
    ProlongingsCalculatorComponent,
    ProlongingsCheckoutComponent,
    ProlongingsAdditionalProductsComponent,
    KmCatchUpCalculatorComponent,
    KmCatchUpCheckoutComponent,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "da-DK", // 'de-DE' for Germany, 'fr-FR' for France ...
    },
    AuthGuard,
    AuthenticationService,
    EnvironmentService,
    UserService,
    UsedCarAgreementService,
    ProlongingsAgreementService,
    KmCatchUpAgreementService,
    MatrixCalculatorService,
    MatrixCarService,
    ToasterService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts